import BaseMap from '../../BaseMap.jsx'
import usePluginSwap from '../../plugins/usePluginSwap.jsx'
import useDesignTarget from './useDesignTarget.mjs'
import useHotkeys from './useHotkeys.mjs'
import useReadMap from './useReadMap.mjs'
import useMindMapPlugins from './useMindMapPlugins.mjs'
import usePermission from './usePermission.mjs'
import LeftPanel from './LeftPanel.jsx'
import usePluginIsrf from './usePluginIsrf.jsx'
import ToolBar from './ToolBar/ToolBar.jsx'

import {
    usePluginCommands,
    usePluginPublishProduct,
    usePluginPullProduct,
    usePluginPushProduct,
    usePluginRefreshProduct,
    usePluginReviseProduct,
    usePluginSaveMap,
    usePluginUndoReviseProduct,
} from './plugins'

const components = {LeftPanel, ToolBar}

export default function ProductMap({id, permission, type, ...props}) {
    const readMap = useReadMap(id, type)
    const hotkeys = useHotkeys()

    const plugins = [
        useDesignTarget({productId: id, productType: type}),
        useMindMapPlugins(),
        usePermission(permission),
        usePluginSwap(),
        usePluginIsrf(),
        usePluginCommands(),
        usePluginPublishProduct(),
        usePluginPullProduct(),
        usePluginPushProduct(),
        usePluginRefreshProduct(),
        usePluginReviseProduct(),
        usePluginSaveMap(),
        usePluginUndoReviseProduct(),
    ]

    return (
        <BaseMap
            components={components}
            hotkeys={hotkeys}
            permission={permission}
            plugins={plugins}
            readMap={readMap}
            {...props}
        />
    )
}
